export const STAKEBOAT_COMPANIES = [
  {
    id: "economy-process",
    name: "Economy Process Solutions",
    sector: "Industrial Manufacturing",
    headcount: 850,
    asbc_gap: 42000000,
    labour_cost: 180000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/economy-process-stakeboat-2026",
    signal: "amber",
    urgency_reason: "Automation potential in manufacturing ops untapped",
    functions: ["Manufacturing Ops", "Quality & Compliance", "Supply Chain", "Engineering", "Finance", "HR & People"],
    competitors: [
      { name: "Economy Process Solutions", score: 38, isTarget: true },
      { name: "Thermax", score: 56 },
      { name: "Praj Industries", score: 62 },
      { name: "Ion Exchange", score: 48 },
      { name: "VA Tech WABAG", score: 54 },
    ],
    velocity_headline: "Manufacturing peers adopting automation 1.5\u00d7 faster",
    leadership_scores: [5, 6, 4, 4, 5, 5, 5],
    readiness_score: 55,
    readiness_drivers: [
      "Manufacturing ops automation potential largely untapped",
      "Small headcount makes transformation achievable in 6 months",
      "Quality & compliance functions over-staffed vs benchmarks",
    ],
  },
  {
    id: "newgen-digital",
    name: "Newgen DigitalWorks",
    sector: "Publishing Technology",
    headcount: 1200,
    asbc_gap: 58000000,
    labour_cost: 220000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/newgen-digital-stakeboat-2026",
    signal: "red",
    urgency_reason: "AI disrupting publishing workflows at pace",
    functions: ["Content Operations", "Technology", "Client Services", "Digital Production", "Finance", "HR & People"],
    competitors: [
      { name: "Newgen DigitalWorks", score: 32, isTarget: true },
      { name: "Straive", score: 68 },
      { name: "Aptara", score: 58 },
      { name: "SPi Global", score: 72 },
      { name: "Cenveo Publisher", score: 51 },
    ],
    velocity_headline: "AI disrupting publishing workflows at 2.2\u00d7 sector pace",
    leadership_scores: [4, 5, 4, 3, 4, 4, 5],
    readiness_score: 68,
    readiness_drivers: [
      "GenAI tools directly replacing content production tasks",
      "Digital & AI leadership capability critically low at 3/10",
      "Client demand for AI-augmented delivery accelerating",
    ],
  },
  {
    id: "dvara-kgfs",
    name: "Dvara KGFS",
    sector: "Financial Services",
    headcount: 3500,
    asbc_gap: 95000000,
    labour_cost: 350000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/dvara-kgfs-stakeboat-2026",
    signal: "red",
    urgency_reason: "Fintech peers restructuring field force faster",
    functions: ["Field Operations", "Technology", "Credit & Risk", "Customer Service", "Finance", "HR & People"],
    competitors: [
      { name: "Dvara KGFS", score: 30, isTarget: true },
      { name: "Bandhan Bank", score: 55 },
      { name: "Ujjivan SFB", score: 62 },
      { name: "Jana SFB", score: 48 },
      { name: "Fincare SFB", score: 58 },
    ],
    velocity_headline: "Fintech peers restructuring field force 2\u00d7 faster",
    leadership_scores: [5, 7, 3, 3, 5, 5, 6],
    readiness_score: 72,
    readiness_drivers: [
      "3,500-person field force at high digitisation risk",
      "Fintech competitors already deploying AI-first models",
      "Technology leadership gap at 3/10 is critical",
    ],
  },
  {
    id: "akara-pharma",
    name: "Akara Pharma",
    sector: "Pharmaceuticals",
    headcount: 600,
    asbc_gap: 28000000,
    labour_cost: 120000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/akara-pharma-stakeboat-2026",
    signal: "amber",
    urgency_reason: "Regulatory and QA functions over-resourced",
    functions: ["Manufacturing", "Quality & Regulatory", "R&D", "Commercial", "Finance", "HR & People"],
    competitors: [
      { name: "Akara Pharma", score: 42, isTarget: true },
      { name: "Glenmark", score: 58 },
      { name: "Alkem Labs", score: 52 },
      { name: "Torrent Pharma", score: 61 },
      { name: "Ipca Labs", score: 48 },
    ],
    velocity_headline: "Regulatory automation lagging pharma sector median",
    leadership_scores: [5, 6, 5, 4, 5, 5, 6],
    readiness_score: 52,
    readiness_drivers: [
      "QA and regulatory functions over-resourced vs sector benchmarks",
      "Small headcount enables rapid transformation execution",
      "R&D automation potential moderate but growing",
    ],
  },
  {
    id: "techsme-platform",
    name: "TechSME Platform",
    sector: "Technology Services",
    headcount: 450,
    asbc_gap: 22000000,
    labour_cost: 95000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/techsme-stakeboat-2026",
    signal: "green",
    urgency_reason: "Strong digital foundation — optimise now",
    functions: ["Engineering", "Product", "Client Delivery", "Sales", "Finance", "HR & People"],
    competitors: [
      { name: "TechSME Platform", score: 62, isTarget: true },
      { name: "Freshworks", score: 78 },
      { name: "Zoho", score: 74 },
      { name: "Druva", score: 68 },
      { name: "Postman", score: 72 },
    ],
    velocity_headline: "Strong digital base but optimisation opportunity exists",
    leadership_scores: [6, 5, 7, 7, 5, 6, 6],
    readiness_score: 38,
    readiness_drivers: [
      "Already tech-forward — smallest gap in portfolio",
      "Optimisation rather than transformation required",
      "Product and engineering teams well-structured",
    ],
  },
];
